<template>
	<div class="pointer-events-none fixed flex flex-col inset-0 items-end px-4 py-6 sm:items-start sm:p-6 z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
		<!-- Background backdrop, show/hide based on slide-over state. -->
		<transition appear
					enter-active-class="transform transition-all ease-in-out duration-500" enter-class="opacity-0" enter-to-class="opacity-100"
					leave-active-class="transform transition-all ease-in-out duration-500" leave-class="opacity-100" leave-to-class="opacity-0">
			<div v-if="overlay && open" class="fixed inset-0 backdrop-blur-sm bg-black/20" @click="handleClickAway"></div>
		</transition>
		<div class="absolute inset-0 overflow-hidden">
			<!-- Content !-->
			<div class="fixed w-screen h-screen inset-y-0 right-0 pointer-events-none flex flex-col">
				<transition
					appear
					appear-active-class="transform transition-all ease-in-out duration-500" :appear-class="transitionEnter" :appear-to-class="transitionEnterTo"
					enter-active-class="transform transition-all ease-in-out duration-500" :enter-class="transitionEnter" :enter-to-class="transitionEnterTo"
					leave-active-class="transform transition-all ease-in-out duration-300" :leave-class="transitionLeave" :leave-to-class="transitionLeaveTo">
					<slot v-if="open" :handlers="{ close: handleClose }"/>
				</transition>
			</div>
		</div>
	</div>

</template>

<script>

export default {
	name: "ModalContainer",
	props: {
		open: Boolean,
		size: {
			type: String,
			default: 'w-screen max-w-md'
		},
		type: {
			type: String,
			default: null
		},
		overlay: Boolean,
		freezeScroll: Boolean,
		transitionEnter: {
			type: String,
			default: 'opacity-0'
		},
		transitionEnterTo: {
			type: String,
			default: 'opacity-100'
		},
		transitionLeave: {
			type: String,
			default: 'opacity-0'
		},
		transitionLeaveTo: {
			type: String,
			default: 'opacity-100'
		},
	},
	model: {
		prop: 'open',
		event: 'update:open',
	},
	methods: {
		handleClose() {
			this.$emit('update:open', false)
			this.$emit('close')
		},
		handleOpen() {
			this.$emit('open')
		},
		handleCloseByKey(event) {
			if (event?.key === 'Escape' && this.open) {
				this.handleClose()
			}
		},
		handleClickAway(event) {
			if (this.open && !event.target.closest('.slide-container')) {
				this.handleClose()
			}
		}
	},
	watch: {
		open: {
			immediate: true,
			handler(v) {

				v && this.freezeScroll
					? document.body.classList.add('h-screen', 'overflow-hidden')
					: document.body.classList.remove('h-screen', 'overflow-hidden')

				if (v) {
					document.addEventListener('keydown', this.handleCloseByKey)
				} else {
					document.removeEventListener('keydown', this.handleCloseByKey)
				}
			}
		}
	}
}
</script>
